import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ExpandCircleUpIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 15 15">
      <path
        d="m7.5 7.05 1.583 1.583a.62.62 0 0 0 .459.184.68.68 0 0 0 .475-.184.65.65 0 0 0 .2-.475.65.65 0 0 0-.2-.475l-2.05-2.05a.64.64 0 0 0-.467-.2.64.64 0 0 0-.467.2L4.967 7.7a.6.6 0 0 0-.192.466.67.67 0 0 0 .208.467.7.7 0 0 0 .467.192.61.61 0 0 0 .467-.192zm6.667.45q0 1.383-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.524 6.5 6.5 0 0 1-2.6-.524 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.358 10.1a6.5 6.5 0 0 1-.525-2.6q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.425A6.5 6.5 0 0 1 7.5.833q1.383 0 2.6.525t2.117 1.425T13.642 4.9t.525 2.6"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
